const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-0">
      <div className="p-6">
        <p className="text-center text-white text-sm italic">
          © {currentYear}{" "}
          <a
            className="underline"
            href="https://www.udtlakshan.com"
            target="_blank"
          >
            Tharindu Lakshan
          </a>
          . All right reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
